export const IS_DEVELOPMENT_ENV =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export const IS_LOCALHOST =
  IS_DEVELOPMENT_ENV &&
  ['localhost', '127.0.0.1', '192.168.'].some((addr) =>
    window.location.hostname.startsWith(addr)
  )

/**
 * handles bash envsubst command
 * @param variableKey - envsubst key with syntax $KEY
 * @param {string | number | boolean} defaultValue - Accepts any string, number, or boolean as a default value.
 */
export const pickEnv = (variableKey: string, defaultValue: string) => {
  const trimmedKey = variableKey.replace('$', '').replace('REACT_APP_', '')

  return IS_LOCALHOST
    ? process.env?.[`REACT_APP_${trimmedKey}`] || defaultValue
    : process.env?.[trimmedKey] || variableKey
}

export const LANGUAGES = {
  ENGLISH: 'en',
  GERMAN: 'de',
}

export const LICENSE_FIELDS = {
  NAME: 'name',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PACKAGE: 'package',
  REVOKE_OLD_LICENSE: 'revokeOldLicense',
}

export const FIELD_SIZES = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
}

export const TAB_KEYS = {
  OVERVIEW: 'overview',
  LICENSES: 'licenses',
  SETTINGS: 'settings',
}

export const ALL_ITEMS_PAGE_SIZE = 100000

export const PAGE_PARAM = 'page'
export const PAGE_SIZE_PARAM = 'page_size'
export const ALERT_HIDE_TIMEOUT = 10000

export const MANAGEMENT_TYPE = {
  PLATFORM: 'platform',
  STANDALONE: 'standalone',
}

export const ALERT_STYLE = {
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'end',
  left: '10px',
  top: 0,
  bottom: '10px',
  transform: 'none',
  width: 'auto',
  zIndex: 1000,
}

export enum ALERT_TYPES {
  SUCCESS = 'success',
  ERROR = 'error',
}

export const LICENSE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PLANNED: 'planned',
}

export const BANNER_TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
}
